import React from 'react'
import {
	Form,
	Input,
	Select,
	Card,
	Button,
	Popconfirm,
	Switch,
	DatePicker,
	notification,
} from 'antd'

import axios from 'axios'
import apiPath from 'apiPath'
import moment from 'components/momentWithZone'
import withSpin from 'components/withSpin'
import CardListForm from 'components/CardListForm'
import formItemLayout from 'components/Portal/formItemLayout'

import { configurableSections, undisableableSections } from './sections'

const possiblePersonTypes = [
	'all',
	'all except waitlist',
	'students',
	'gap/post students',
	'non-gap/post students',
	'staff',
	'faculty',
	'life long learners',
	'waitlisted',
]

class RuleForm extends React.Component {
	state = {
		configRules: [],
		showShowRange: false,
		showEnableRange: false,
	}

	checkIfShowDates = (props) => {
		this.setState({
			showShowRange:
				props.rule &&
				props.rule.showAlways !== '1' &&
				props.rule.showAlways !== true,
			showEnableRange:
				props.rule &&
				props.rule.enableAlways !== '1' &&
				props.rule.enableAlways !== true,
		})
	}
	handleSubmit = (event) => {
		event.preventDefault()
		this.props.form.validateFields((err, values) => {
			if (err) return console.error(err)
			this.props.onSave(this.props.rule.index, values)
		})
	}
	componentDidMount() {
		this.checkIfShowDates(this.props)
	}
	render() {
		const { getFieldDecorator } = this.props.form
		let {
			voyage,
			section,
			personTypes,
			showAlways,
			enableAlways,
			showFrom,
			hideAfter,
			enableFrom,
			disableAfter,
			saved,
			id,
		} = this.props.rule
		showFrom = showFrom ? moment.parseZone(showFrom).local() : null
		hideAfter = hideAfter ? moment.parseZone(hideAfter).local() : null
		enableFrom = enableFrom ? moment.parseZone(enableFrom).local() : null
		disableAfter = disableAfter
			? moment.parseZone(disableAfter).local()
			: null
		const disabled = saved

		return (
			<Card>
				<Form onSubmit={this.handleSubmit}>
					{disabled && (
						<Form.Item style={{ textAlign: 'right' }}>
							<Button
								icon='edit'
								onClick={this.props.onEdit.bind(
									this,
									this.props.rule.index
								)}
							>
								Edit
							</Button>
						</Form.Item>
					)}
					{!disabled && (
						<Form.Item style={{ textAlign: 'right' }}>
							<Popconfirm
								title='Are you sure?'
								okText='Remove'
								cancelText='Cancel'
								onConfirm={this.props.onRemove.bind(
									this,
									this.props.rule.index
								)}
							>
								<Button
									type='danger'
									size='large'
									icon='delete'
								>
									Remove
								</Button>
							</Popconfirm>
							<Button
								type='primary'
								htmlType='submit'
								icon='save'
							>
								Save
							</Button>
						</Form.Item>
					)}
					<br />
					<br />
					<Form.Item
						label='For voyage'
						colon={false}
						{...formItemLayout}
					>
						{getFieldDecorator('voyage', {
							initialValue: voyage,
						})(
							<Select size='default' disabled={disabled}>
								{this.props.voyages && this.props.voyages.map((voyage) => (
									<Select.Option
										key={voyage.id}
										value={voyage.id}
									>
										{voyage.code}
									</Select.Option>
								))}
							</Select>
						)}
					</Form.Item>
					<Form.Item
						label='and person type(s)'
						colon={false}
						{...formItemLayout}
					>
						{getFieldDecorator('personTypes', {
							initialValue: personTypes,
						})(
							<Select size='default' disabled={disabled}>
								{possiblePersonTypes.map((option) => (
									<Select.Option key={option} value={option}>
										{option}
									</Select.Option>
								))}
							</Select>
						)}
					</Form.Item>
					<Form.Item
						label='and section'
						colon={false}
						{...formItemLayout}
					>
						{getFieldDecorator('section', {
							initialValue: section,
						})(
							<Select size='default' disabled={disabled}>
								{configurableSections.map((option) => (
									<Select.Option key={option} value={option}>
										{option}
									</Select.Option>
								))}
							</Select>
						)}
					</Form.Item>
					<Form.Item
						label='Always show?'
						colon={false}
						{...formItemLayout}
					>
						{getFieldDecorator('showAlways', {
							initialValue: showAlways,
						})(
							<Switch
								size='small'
								defaultChecked={
									showAlways === '1' || showAlways === true
								}
								checked={!this.state.showShowRange}
								onChange={(checked) =>
									this.setState({ showShowRange: !checked })
								}
								disabled={disabled}
							/>
						)}
					</Form.Item>
					{this.state.showShowRange && (
						<Form.Item
							label='Show during this range'
							{...formItemLayout}
						>
							{getFieldDecorator('showRange', {
								initialValue: [showFrom, hideAfter],
								rules: [
									{
										validator: (rule, value, callback) => {
											if (
												value[0] === null ||
												value[1] === null
											)
												return callback(
													'Date range required'
												)
											return callback()
										},
									},
								],
							})(
								<DatePicker.RangePicker
									size='default'
									showTime={{
										format: 'HH:mm',
										defaultValue: [
											moment('00:00', 'HH:mm'),
											moment('00:00', 'HH:mm'),
										],
									}}
									format='YYYY-MM-DD HH:mm'
									placeholder={['Show From', 'Hide After']}
									disabled={disabled}
									//onChange={onChange}
									//onOk={onOk}
								/>
							)}
						</Form.Item>
					)}
					{undisableableSections.indexOf(
						this.props.form.getFieldValue('section')
					) === -1 && (
						<div>
							<Form.Item
								label='Always enable?'
								colon={false}
								{...formItemLayout}
							>
								{getFieldDecorator('enableAlways', {
									initialValue: enableAlways,
								})(
									<Switch
										size='small'
										defaultChecked={
											enableAlways === '1' ||
											enableAlways === true
										}
										checked={!this.state.showEnableRange}
										onChange={(checked) =>
											this.setState({
												showEnableRange: !checked,
											})
										}
										disabled={disabled}
									/>
								)}
							</Form.Item>
							{this.state.showEnableRange && (
								<Form.Item
									label='Enable during this range'
									{...formItemLayout}
								>
									{getFieldDecorator('enableRange', {
										initialValue: [
											enableFrom,
											disableAfter,
										],
										rules: [
											{
												validator: (
													rule,
													value,
													callback
												) => {
													if (
														value[0] === null ||
														value[1] === null
													)
														return callback(
															'Date range required'
														)
													return callback()
												},
											},
										],
									})(
										<DatePicker.RangePicker
											size='default'
											showTime={{
												format: 'HH:mm',
												defaultValue: [
													moment('00:00', 'HH:mm'),
													moment('00:00', 'HH:mm'),
												],
											}}
											format='YYYY-MM-DD HH:mm'
											placeholder={[
												'Enable From',
												'Disable After',
											]}
											disabled={disabled}
											//onChange={onChange}
											//onOk={onOk}
										/>
									)}
								</Form.Item>
							)}
						</div>
					)}
					<Form.Item>
						{getFieldDecorator('id', {
							initialValue: id,
						})(<Input type='hidden' />)}
					</Form.Item>
				</Form>
			</Card>
		)
	}
}

const WrappedRuleForm = Form.create()(RuleForm)

class PortalConfig extends React.Component {
	state = {
		rules: [],
	}
	handleChange = (s) => {
		this.setState(s)
	}
	handleSave = (rule, s, index) => {
		this.props.isLoading()
		let submitRule = Object.assign({}, rule)
		if (submitRule.showRange) {
			submitRule.showFrom = moment(submitRule.showRange[0]).toISOString()
			submitRule.hideAfter = moment(submitRule.showRange[1]).toISOString()
		}
		if (submitRule.enableRange) {
			submitRule.enableFrom = moment(
				submitRule.enableRange[0]
			).toISOString()
			submitRule.disableAfter = moment(
				submitRule.enableRange[1]
			).toISOString()
		}
		axios
			.put(apiPath + '/portalconfig', submitRule, {
				withCredentials: true,
			})
			.then((response) => {
				if (!submitRule.id) s.rules[index].id = response.data
				if (submitRule.showFrom)
					s.rules[index].showFrom = submitRule.showFrom
				if (submitRule.hideAfter)
					s.rules[index].hideAfter = submitRule.hideAfter
				if (submitRule.enableFrom)
					s.rules[index].enableFrom = submitRule.enableFrom
				if (submitRule.disableAfter)
					s.rules[index].disableAfter = submitRule.disableAfter
				this.props.isDoneLoading()
				this.setState(s)
			})
			.catch((error) => {
				this.props.isDoneLoading()
				notification.error({
					message: error.message,
					duration: 0,
				})
				console.error(error)
			})
	}
	handleRemove = (rule, s) => {
		if (!rule.id) return this.setState(s)
		this.props.isLoading()
		axios
			.delete(apiPath + '/portalconfig', {
				data: rule,
				withCredentials: true,
			})
			.then((result) => {
				this.props.isDoneLoading()
				this.setState(s)
			})
			.catch((error) => {
				this.props.isDoneLoading()
				notification.error({
					message: error.message,
					duration: 0,
				})
				console.error(error)
			})
	}
	getRules = () => {
		return axios
			.get(apiPath + '/portalconfig', { withCredentials: true })
			.then((response) => {
				this.setState({
					rules: response.data.map((rule) => {
						rule.saved = true
						return rule
					}),
				})
			})
	}
	componentDidMount() {
		this.getRules()
	}

	render() {
		let i = 0
		return (
			<div style={{ padding: '8pt' }}>
				<CardListForm
					title='Rule'
					thing='rules'
					rules={this.state.rules}
					onChange={this.handleChange}
					onSave={this.handleSave}
					onRemove={this.handleRemove}
				>
					{this.state.rules.map((rule) => {
						rule.index = i
						let key = i
						if (rule.id) key += '_' + rule.id
						i++
						return (
							<WrappedRuleForm
								key={key}
								rule={rule}
								voyages={this.props.voyages}
							/>
						)
					})}
				</CardListForm>
			</div>
		)
	}
}

export default withSpin(PortalConfig)



// WEBPACK FOOTER //
// ./portal-components/Portal/AdminConfig/index.jsx